/* Sowth volume ladder + live savings badge
 * 1) Turns pack/quantity variant pills into premium "choose your pack" cards.
 * 2) Keeps the #SowthSavings badge in sync with the SELECTED variant.
 * Radio inputs are untouched (cart unaffected). */
(function () {
  var PROD = null, fetching = false;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function injectCSS() {
    if (document.getElementById('sowth-vl-css')) return;
    var s = document.createElement('style');
    s.id = 'sowth-vl-css';
    s.textContent = '.product-form__input--pill.sowth-vl{display:flex;flex-direction:column;gap:.8rem;border:0;padding:0;margin:0 0 1.6rem}.product-form__input--pill.sowth-vl>legend.form__label{float:none;margin:0 0 .7rem;font-weight:700}.sowth-vl input[type="radio"]{position:absolute!important;width:1px;height:1px;opacity:0;pointer-events:none}.product-form__input--pill.sowth-vl label{display:flex!important;flex-direction:column;gap:.45rem;width:100%;max-width:none;height:auto;min-height:0;margin:0!important;padding:1.15rem 1.3rem!important;border:1.5px solid rgba(5,88,95,.16)!important;border-radius:14px!important;background:#fff!important;color:#0c3b3a!important;cursor:pointer;transition:border-color .18s,box-shadow .18s,background .18s;text-align:left}.product-form__input--pill.sowth-vl input:checked+label{border-color:#0a6a63!important;background:#0a6a63!important;box-shadow:0 6px 16px rgba(10,106,99,.28)!important}.product-form__input--pill.sowth-vl input:checked+label .sowth-vl__name{color:#fff!important}.product-form__input--pill.sowth-vl input:checked+label .sowth-vl__per{color:rgba(255,255,255,.88)!important}.product-form__input--pill.sowth-vl input:checked+label .sowth-vl__save{color:#ffd9cf!important}.product-form__input--pill.sowth-vl input:checked+label .sowth-vl__badge{background:#fff!important;color:#0a6a63!important;border-color:#fff!important}.sowth-vl__row{display:flex;align-items:center;justify-content:space-between;gap:.8rem}.sowth-vl__name{font-size:1.5rem;font-weight:800}.sowth-vl__badge{font-size:1.02rem;font-weight:800;color:#147a3b;background:#e4f5ea;border:1px solid #bfe6cd;padding:.25rem .7rem;border-radius:999px;white-space:nowrap}.sowth-vl__meta{display:flex;align-items:center;justify-content:space-between;gap:.8rem}.sowth-vl__per{font-size:1.25rem;color:#5f7276;font-weight:600}.sowth-vl__save{font-size:1.25rem;font-weight:800;color:#ff6a4d}';
    document.head.appendChild(s);
  }
  function currentVariant(p) {
    var idInput = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"], variant-selects input[name="id"]');
    if (idInput && idInput.value) { for (var i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === String(idInput.value)) return p.variants[i]; } }
    var sels = document.querySelectorAll('.product-form__input input[type="radio"]:checked, variant-selects select');
    var chosen = []; [].forEach.call(sels, function (s) { var v = (s.value || '').trim(); if (v) chosen.push(v); });
    if (chosen.length) { for (var j = 0; j < p.variants.length; j++) { var vr = p.variants[j], ok = true; for (var k = 0; k < vr.options.length; k++) { if (chosen.indexOf(vr.options[k]) < 0) { ok = false; break; } } if (ok) return vr; } }
    for (var m = 0; m < p.variants.length; m++) { if (p.variants[m].available) return p.variants[m]; }
    return p.variants[0];
  }
  function updateSavings(p) {
    var el = document.getElementById('SowthSavings');
    if (!el) return;
    var v = currentVariant(p);
    if (v && v.compare_at_price && v.compare_at_price > v.price) {
      var txt = 'Save ' + money(v.compare_at_price - v.price) + ' (' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% off)';
      if (el.textContent !== txt) el.textContent = txt;
      el.hidden = false;
      if (el.style.display === 'none') el.style.display = '';
    } else {
      el.hidden = true;
      if (el.style.display !== 'none') el.style.display = 'none';
    }
  }
  function doEnhance(p) {
    var fieldsets = document.querySelectorAll('.product-form__input--pill');
    if (!fieldsets.length) return;
    var byTitle = {};
    p.variants.forEach(function (v) { byTitle[v.title] = v; });
    [].forEach.call(fieldsets, function (fs) {
      if (fs.__sowthVL) return;
      var legend = fs.querySelector('legend');
      var optName = legend ? legend.textContent.trim() : '';
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (inputs.length < 2) return;
      var packish = /amount|pack|qty|quantit|bundle|piece|pcs?|set|count/i.test(optName) || /\b\d+\s*(pc|pcs|pack|piece|set|x)\b/i.test(inputs[0].value);
      if (!packish) return;
      var data = [], ok = true;
      inputs.forEach(function (inp) {
        var v = byTitle[inp.value];
        if (!v) { ok = false; return; }
        var qty = parseInt(inp.value, 10) || 1;
        data.push({ inp: inp, v: v, qty: qty, per: v.price / qty });
      });
      if (!ok || data.length < 2) return;
      var anySave = false;
      data.forEach(function (d) {
        d.save = (d.v.compare_at_price && d.v.compare_at_price > d.v.price) ? Math.round((d.v.compare_at_price - d.v.price) / d.v.compare_at_price * 100) : 0;
        if (d.save > 0) anySave = true;
      });
      var pers = data.map(function (d) { return d.per; });
      var differ = Math.max.apply(null, pers) - Math.min.apply(null, pers) > 1;
      if (!anySave && !differ) return;
      var best = data.reduce(function (a, b) { return b.per < a.per ? b : a; });
      injectCSS();
      if (legend) legend.textContent = 'Choose your pack';
      data.forEach(function (d) {
        var label = fs.querySelector('label[for="' + d.inp.id + '"]');
        if (!label) return;
        var vh = label.querySelector('.visually-hidden');
        var isBest = (d === best && d.qty > 1);
        var h = '<span class="sowth-vl__row"><span class="sowth-vl__name">' + d.inp.value + '</span>';
        if (isBest) h += '<span class="sowth-vl__badge">Best value</span>';
        h += '</span><span class="sowth-vl__meta"><span class="sowth-vl__per">' + money(d.per) + ' / item</span>';
        if (d.save > 0) h += '<span class="sowth-vl__save">Save ' + d.save + '%</span>';
        h += '</span>';
        label.innerHTML = h;
        if (vh) label.appendChild(vh);
      });
      fs.classList.add('sowth-vl');
      fs.__sowthVL = true;
    });
  }
  function run(p) { doEnhance(p); updateSavings(p); }
  function enhance() {
    if (!document.querySelector('.product-form__input--pill') && !document.getElementById('SowthSavings')) return;
    var path = location.pathname, idx = path.indexOf('/products/');
    if (idx < 0) return;
    if (PROD) { run(PROD); return; }
    if (fetching) return;
    fetching = true;
    var handle = path.slice(idx + 10).split('/')[0].split('?')[0].split('#')[0];
    fetch('/products/' + handle + '.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (p) { PROD = p; fetching = false; run(p); }).catch(function () { fetching = false; });
  }
  function start() {
    enhance();
    var host = document.querySelector('product-info') || document.querySelector('.product') || document.querySelector('main') || document.body;
    if ('MutationObserver' in window) { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(enhance, 90); }).observe(host, { childList: true, subtree: true }); }
    document.addEventListener('change', function (e) { var el = e.target; if (el && el.matches && el.matches('input[type="radio"], select') && PROD) { setTimeout(function () { updateSavings(PROD); }, 80); } });
  }
  if (document.querySelector('.product-form__input--pill') || document.getElementById('SowthSavings')) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})();
